import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EventItem, StrutEventEnum, StrutEventExtended } from '../../models';


/**
 * Component for events in dashboard calendar.
 */
@Component({
	selector: 'calendar-events',
	templateUrl: './calendar-events.component.html',
	imports: [
		NgbTooltipModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class CalendarEventsComponent {

	@Input() set events(list: EventItem[] | undefined) {
		this.strutChanges = list?.find(i => i.type === StrutEventEnum.CHANGE)?.items ?? [];
		this.strutAdjusts = list?.find(i => i.type === StrutEventEnum.ADJUST)?.items ?? [];
	}

	strutAdjusts: StrutEventExtended[] = [];
	strutChanges: StrutEventExtended[] = [];
	strutEventEnum = StrutEventEnum;


	/**
	 * Get formatted description of event item.
	 */
	eventItemDesc(item: StrutEventExtended): string {
		return `${item.patientNumber}, ${item.caseNumber}, Frame ${item.frameID}`;
	}

}
